import { EXTENSIONS_ENUM } from 'constants/ExtensionConstants';
import { BODYWORK_APPOINTMENT, PARTS_REMINDER, REMINDER } from 'constants/FeatureConstants';

import { PARTS, SALES, TECHNICIAN } from 'constants/ModeConstants';
import { PATH } from 'constants/RoutesConstants';

import { FeaturesEnum } from 'modules/global/typing/enums/features.enum';

import ChatMenuItem from './Chat';

/**
 * @typedef {{
 *  icon: string,
 *  name: string,
 *  classItemMenu?: string,
 *  to?: import('react-router').RouteProps,
 *  children?:Array<Section>,
 *  iconOverride?: React.FC
 *  extension?: Array<EXTENSIONS_ENUM>
 *  features?: Array<FeaturesEnum>
 * }} Section
 */

/** @type {Array<Section>} */
const Sections = [
  {
    id: 'after-sales',
    classItemMenu: 'extension',
    'data-cy': 'afterSales_Navigation_Btn',
    icon: 'fb-icon--ext-after-sales',
    name: 'after_sales',
    extension: [EXTENSIONS_ENUM.AFTER_SALES, EXTENSIONS_ENUM.SELF_SERVICE],
    children: [
      {
        id: 'after-sales-dashboard',
        to: PATH.AFTERSALES,
        name: 'navigation.dashboard',
        'data-cy': 'interventions_AfterSales_Navigation_Btn',
      },
      {
        id: 'reminders-dashboard',
        to: PATH.REMINDERS,
        name: 'navigation.reminders',
        'data-cy': 'reminders_AfterSales_Navigation_Btn',
        extension: REMINDER,
      },
      {
        id: 'after-sales-followUp-dashboard',
        to: PATH.FOLLOW_UP,
        params: { mode: TECHNICIAN },
        name: 'customSteps.fixedStep.follow_up',
        'data-cy': 'followUp_AfterSales_Navigation_Btn',
      },
      {
        id: 'bodywork-dashboard',
        to: PATH.BODYWORKS,
        name: 'navigation.bodywork_appointment',
        'data-cy': 'chatbot_AfterSales_Navigation_Btn',
        extension: BODYWORK_APPOINTMENT,
      },
      {
        id: 'statistics-after-sales',
        to: PATH.STATS_AFTER_SALES,
        name: 'navigation.statistics.title',
        'data-cy': 'after_sales_Statistics_Navigation_Btn',
      },
    ],
  },
  {
    id: 'self-service',
    classItemMenu: 'extension',
    'data-cy': 'selfService_Navigation_Btn',
    icon: 'fb-icon--ext-self-service',
    name: 'self_service',
    extension: EXTENSIONS_ENUM.SELF_SERVICE,
    children: [
      {
        id: 'kanban',
        to: PATH.SELF_SERVICE_KANBAN,
        name: 'navigation.dashboard',
        'data-cy': 'kanban_AfterSales_Navigation_Btn',
      },
      {
        id: 'mobility-dashboard',
        to: PATH.SELF_SERVICE_MOBILITY,
        name: 'page.config.dealer_general.selfService.mobility.title',
        'data-cy': 'mobility_AfterSales_Navigation_Btn',
      },
      {
        id: 'statistics-self-service',
        to: PATH.SELF_SERVICE_STATS_DASHBOARD,
        name: 'navigation.statistics.title',
        'data-cy': 'selfService_Statistics_Navigation_Btn',
      },
    ],
  },
  {
    id: 'parts-button',
    classItemMenu: 'extension',
    'aria-controls': 'parts-sales',
    'data-cy': 'parts_category_Navigation_Btn',
    icon: 'fb-icon--ext-parts',
    name: 'parts',
    extension: EXTENSIONS_ENUM.PARTS,
    children: [
      {
        id: 'parts-dashboard',
        to: PATH.PARTS,
        name: 'navigation.dashboard',
        'data-cy': 'parts_Navigation_Btn',
        extension: EXTENSIONS_ENUM.PARTS,
      },
      {
        id: 'parts-reminder-dashboard',
        to: PATH.PARTS_REMINDER,
        name: 'navigation.reminders',
        'data-cy': 'parts_Navigation_Btn',
        extension: PARTS_REMINDER,
      },
      {
        id: 'parts-followUp-dashboard',
        to: PATH.FOLLOW_UP,
        params: { mode: PARTS },
        name: 'customSteps.fixedStep.follow_up',
        'data-cy': 'followUp_parts_Navigation_Btn',
      },
      {
        id: 'statistics-parts',
        to: PATH.STATS_PARTS,
        name: 'navigation.statistics.title',
        'data-cy': 'parts_Statistics_Navigation_Btn',
      },
    ],
  },
  {
    id: 'sales',
    classItemMenu: 'extension',
    'data-cy': 'sales_category_Navigation_Btn',
    icon: 'fb-icon--ext-sales',
    name: 'sales',
    extension: EXTENSIONS_ENUM.SALES,
    children: [
      {
        id: 'sales-dashboard',
        to: PATH.SALES,
        name: 'navigation.dashboard',
        'data-cy': 'sales_Navigation_Btn',
      },
      {
        id: 'leads-dashboard',
        to: PATH.LEADS,
        name: 'leads',
        'data-cy': 'leads_Navigation_Btn',
      },
      {
        id: 'sales-followUp-dashboard',
        to: PATH.FOLLOW_UP,
        params: { mode: SALES },
        name: 'customSteps.fixedStep.follow_up',
        'data-cy': 'followUp_sales_Navigation_Btn',
      },
      {
        id: 'statistics-sales',
        to: PATH.STATS_SALES,
        name: 'navigation.statistics.title',
        'data-cy': 'sales_Statistics_Navigation_Btn',
      },
    ],
  },
  {
    id: 'audits',
    classItemMenu: 'extension',
    icon: 'fb-icon--ext-audits',
    name: 'navigation.audits',
    'data-cy': 'audits_Navigation_Btn',
    extension: EXTENSIONS_ENUM.AUDIT,
    children: [
      {
        id: 'audits-dashboard',
        to: PATH.AUDITS,
        name: 'navigation.dashboard',
        'data-cy': 'sales_Navigation_Btn',
      },
      {
        id: 'statistics-audits',
        to: PATH.STATS_ODITOO,
        name: 'navigation.statistics.title',
        'data-cy': 'audits_Statistics_Navigation_Btn',
      },
    ]
  },
  {
    id: 'campaigns',
    classItemMenu: 'extension',
    'data-cy': 'campaigns_Navigation_Btn',
    icon: 'fb-icon--ext-campaigns',
    name: 'navigation.campaigns.title',
    extension: EXTENSIONS_ENUM.CAMPAIGN,
    children: [
      {
        id: 'campaigns-dashboard',
        to: PATH.CAMPAIGNS_DASHBOARD,
        name: 'navigation.dashboard',
        'data-cy': 'campaigns_dashboard_Navigation_Btn',
      },
      {
        id: 'contact-lists-dashboard',
        to: PATH.CONTACT_LISTS_DASHBOARD,
        name: 'page.contactLists.dashboard.title',
        'data-cy': 'contactLists_dashboard_Navigation_Btn',
      },
    ],
  },
  {
    id: 'key-deposit',
    classItemMenu: 'extension',
    'data-cy': 'keyDropOff_Navigation_Btn',
    icon: 'fb-icon--ext-appointment-management',
    name: 'navigation.appointment.title',
    extension: EXTENSIONS_ENUM.APPOINTMENT,
    children: [
      {
        id: 'key-deposit-appointments',
        to: PATH.KEY_DROP_OFF_APPOINTMENTS,
        icon: 'fb-icon--submenu',
        name: 'navigation.dashboard',
        'data-cy': 'appointments_KeyDropOff_Navigation_Btn',
      },
      {
        id: 'key-deposit-locker-planning',
        to: PATH.KEY_DROP_OFF_LOCKER_PLANNING,
        icon: 'fb-icon--submenu',
        name: 'navigation.appointment.safe-booking',
        'data-cy': 'calendar_KeyDropOff_Navigation_Btn',
      },
    ],
  },
  {
    id: 'chat',
    to: PATH.CHAT,
    icon: 'fb-icon--ext-chat',
    name: 'navigation.chat',
    'data-cy': 'chat_Navigation_Btn',
    iconOverride: ChatMenuItem,
    extension: EXTENSIONS_ENUM.CHAT,
  },
  {
    id: 'payments',
    to: PATH.PAYMENT,
    icon: 'fb-icon--ext-payments',
    name: 'navigation.payments',
    'data-cy': 'payments_Navigation_Btn',
  },
  {
    id: 'billings',
    'data-cy': 'billings',
    icon: 'fb-icon--ext-usage-metrics',
    name: 'statistics_message_cost.title',
    children: [
      {
        name: 'message',
        id: 'billing-sms-cost',
        to: PATH.MESSAGE_BILLING,
        'data-cy': 'sms_Cost_Navigation_Btn',
      },
      {
        id: 'billing-clipping-cost',
        to: PATH.CLIPPING_BILLING,
        name: 'navigation.billing.clipping',
        'data-cy': 'sms_Cost_Navigation_Btn',
      },
      {
        id: 'automated-document-validation',
        to: PATH.AUTOMATED_DOCUMENT_BILLING,
        extension: [EXTENSIONS_ENUM.SELF_SERVICE],
        features: [FeaturesEnum.AUTOMATED_DOCUMENT_VALIDATION],
        name: 'automatedDocumentValidation',
        'data-cy': 'automated_document_validation_Cost_Navigation_Btn',
      },
      {
        id: 'phone-agent',
        to: PATH.PHONE_AGENT_BILLING,
        features: [FeaturesEnum.PHONE_AGENT],
        name: 'navigation.billing.phoneAgent',
        'data-cy': 'phone_agent_Cost_Navigation_Btn',
      },
    ],
  },
  {
    id: 'customers',
    to: PATH.CUSTOMERS,
    icon: 'fb-icon--ext-customers',
    name: 'navigation.customers',
    'data-cy': 'customers_Navigation_Btn',
  },
  {
    id: 'configurator',
    'data-cy': 'configurator_Navigation_Btn',
    icon: 'fb-icon--ext-configurator',
    name: 'navigation.configurator.title',
    to: PATH.CONFIGURATOR_OFFERS,
  },
  {
    id: 'manufacturer-statistics',
    'data-cy': 'statistics_Navigation_Btn',
    icon: 'fb-icon--ext-statistics',
    name: 'navigation.statistics.title',
    children: [
      {
        id: 'manufacturer-statistics-after-sales',
        to: PATH.MANUFACTURER_STATS_AFTER_SALES,
        name: 'navigation.statistics.after-sales',
        'data-cy': 'after_sales_Statistics_Navigation_Btn',
      },
      {
        id: 'manufacturer-statistics-self-service',
        to: PATH.MANUFACTURER_STATS_SELF_SERVICE,
        name: 'navigation.statistics.selfService',
        'data-cy': 'selfService_Statistics_Navigation_Btn',
      },
      {
        id: 'manufacturer-statistics-parts',
        to: PATH.MANUFACTURER_STATS_PARTS,
        name: 'navigation.statistics.parts',
        'data-cy': 'parts_Statistics_Navigation_Btn',
      },
      {
        id: 'manufacturer-statistics-sales',
        to: PATH.MANUFACTURER_STATS_SALES,
        name: 'navigation.statistics.sales',
        'data-cy': 'sales_Statistics_Navigation_Btn',
      },
    ],
  },
];

export default Sections;
